import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import { JProject } from '@ascschool/interface/project';
import { ProjectConst } from '@ascschool/project/config/const';
import { TranslateService } from '@ngx-translate/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DrawerComponent } from './drawer/drawer.component';
import { PopupComponent } from './popup/popup.component';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import {
  NzTableFilterFn,
  NzTableFilterList,
  NzTableSortFn,
  NzTableSortOrder
} from 'ng-zorro-antd/table';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';

interface DataItem {
  numberIndex: number;
  code: string;
  firstName: string;
  lastName: string;
  gender: string;
  dob: string;
  folk: string;
  age: number;
  employee: boolean;
}
interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn | null;
  listOfFilter: NzTableFilterList | null;
  filterFn: NzTableFilterFn | null;
  filterMultiple: boolean;
  sortDirections: NzTableSortOrder[];
}
@Component({
  selector: 'app-sample1',
  templateUrl: './sample1.component.html',
  styleUrls: ['./sample1.component.scss']
})
export class Sample1Component implements OnInit, AfterViewInit {
  width: number;
  viewHeight: number;
  private elementPageExpandedSearch: ElementRef;
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageSample1', { static: false }) elementPageSample1: ElementRef;
  @ViewChild('pageBreadcrumb', { static: false }) elementBreadcrumb: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('pageExpandedSearch', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageExpandedSearch = content;
    }
  }
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  contentHeight: number;
  heightPagnagation: number = 50;
  heightContentPaddingtop: number = 16;
  heightContentPaddingbottom: number = 16;
  get breadcrumbs(): string[] {
    return [ProjectConst.Projects, 'Sample 1'];
  }
  constructor(
    private modalService: NzModalService,
    private drawerService: NzDrawerService,
    private msg: NzMessageService,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
  ) {}
  listOfColumns: ColumnItem[] = [];
  listOfEmployeeFilter = [
    { text: 'Employee', value: true },
    { text: 'not Employee', value: false }
  ];
  // tslint:disable-next-line: max-line-length
  filterEmloyeeFn = (list: [], item: DataItem) => list.some((employee) => item.employee === employee);
  sortNameFn = (a: DataItem, b: DataItem) => a.lastName.localeCompare(b.lastName);
  sortAgeFn = (a: DataItem, b: DataItem) => a.age - b.age;
  // tslint:disable-next-line: member-ordering
  project: JProject;
  // tslint:disable-next-line: member-ordering
  isOpen: boolean = false;
  // tslint:disable-next-line: member-ordering
  filterEmloyee = [
    { text: 'male', value: 'male' },
    { text: 'female', value: 'female' }
  ];
  // tslint:disable-next-line: member-ordering
  listOfData: DataItem[] = [
    {
      numberIndex: 1,
      code: '1900177326',
      firstName: 'Dương Thị Thùy',
      lastName: 'Anh',
      gender: 'Nữ',
      dob: '2004-11-30',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 2,
      code: '1900177327',
      firstName: 'Ngô Phương',
      lastName: 'Anh',
      gender: 'Nữ',
      dob: '2004-10-25',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 3,
      code: '1900177328',
      firstName: 'Tống Duy',
      lastName: 'Anh',
      gender: 'Nam',
      dob: '2004-02-26',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 4,
      code: '1900177332',
      firstName: 'Bùi Xuân',
      lastName: 'Đảm',
      gender: 'Nam',
      dob: '2004-09-13',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 5,
      code: '1900177333',
      firstName: 'Hoàng Ngọc',
      lastName: 'Đạt',
      gender: 'Nam',
      dob: '2004-10-10',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 6,
      code: '1900177334',
      firstName: 'Ngô Duy',
      lastName: 'Đông',
      gender: 'Nam',
      dob: '2004-06-01',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 7,
      code: '1900177329',
      firstName: 'Lê Đăng',
      lastName: 'Dũng',
      gender: 'Nam',
      dob: '2004-01-16',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 8,
      code: '1900177330',
      firstName: 'Nguyễn Trọng',
      lastName: 'Dũng',
      gender: 'Nam',
      dob: '2004-11-18',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 9,
      code: '1900177331',
      firstName: 'Ngô Thị',
      lastName: 'Duyên',
      gender: 'Nữ',
      dob: '2004-09-26',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 10,
      code: '1900177335',
      firstName: 'Nguyễn Thị Hương',
      lastName: 'Giang',
      gender: 'Nữ',
      dob: '2004-06-20',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 11,
      code: '1900177336',
      firstName: 'Dương Thị Khánh',
      lastName: 'Hà',
      gender: 'Nữ',
      dob: '2004-06-13',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 12,
      code: '1900177337',
      firstName: 'Giáp Thị Ngân',
      lastName: 'Hà',
      gender: 'Nữ',
      dob: '2004-04-23',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 13,
      code: '1900177338',
      firstName: 'Nguyễn Thị Vân',
      lastName: 'Hà',
      gender: 'Nữ',
      dob: '2004-11-08',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 14,
      code: '1900177339',
      firstName: 'Vũ Văn',
      lastName: 'Hải',
      gender: 'Nam',
      dob: '2004-07-24',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 15,
      code: '1900177340',
      firstName: 'Ngô Trung',
      lastName: 'Hiếu',
      gender: 'Nam',
      dob: '2004-08-09',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 16,
      code: '1900177341',
      firstName: 'Nguyễn Trung',
      lastName: 'Hiếu',
      gender: 'Nam',
      dob: '2004-11-13',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 17,
      code: '1900177343',
      firstName: 'Nguyễn Mai',
      lastName: 'Hương',
      gender: 'Nữ',
      dob: '2004-01-10',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 18,
      code: '1900177342',
      firstName: 'Đỗ Ngọc',
      lastName: 'Huyền',
      gender: 'Nữ',
      dob: '2004-01-27',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 19,
      code: '1900177344',
      firstName: 'Nguyễn Thanh',
      lastName: 'Kiên',
      gender: 'Nam',
      dob: '2004-03-10',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 20,
      code: '1900177345',
      firstName: 'Nguyễn Trung',
      lastName: 'Kiên',
      gender: 'Nam',
      dob: '2004-03-23',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 21,
      code: '1900177346',
      firstName: 'Nguyễn Thị Khánh',
      lastName: 'Linh',
      gender: 'Nữ',
      dob: '2004-10-17',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 22,
      code: '1900177347',
      firstName: 'Trần Hoàng Bảo',
      lastName: 'Long',
      gender: 'Nam',
      dob: '2004-08-06',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 23,
      code: '1900177348',
      firstName: 'Lưu Văn',
      lastName: 'Minh',
      gender: 'Nam',
      dob: '2004-04-26',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 24,
      code: '1900177349',
      firstName: 'Nguyễn Quang',
      lastName: 'Minh',
      gender: 'Nam',
      dob: '2004-10-12',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 25,
      code: '1900177350',
      firstName: 'Nguyễn Trà',
      lastName: 'My',
      gender: 'Nữ',
      dob: '2004-07-02',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 26,
      code: '1900177351',
      firstName: 'Nguyễn Phương',
      lastName: 'Nguyên',
      gender: 'Nữ',
      dob: '2004-11-08',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 27,
      code: '1900177352',
      firstName: 'Nguyễn Thị Thu',
      lastName: 'Nguyệt',
      gender: 'Nữ',
      dob: '2004-08-30',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 28,
      code: '1900177353',
      firstName: 'Nguyễn Minh',
      lastName: 'Phú',
      gender: 'Nam',
      dob: '2004-09-23',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 29,
      code: '1900177354',
      firstName: 'Ngô Thành',
      lastName: 'Phúc',
      gender: 'Nam',
      dob: '2004-11-12',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 30,
      code: '1900177355',
      firstName: 'Nguyễn Khánh',
      lastName: 'Quyền',
      gender: 'Nam',
      dob: '2004-07-18',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 31,
      code: '1900177356',
      firstName: 'Nguyễn Thị Diễm',
      lastName: 'Quỳnh',
      gender: 'Nữ',
      dob: '2004-06-15',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 32,
      code: '1900177357',
      firstName: 'Nguyễn Ngọc',
      lastName: 'Sơn',
      gender: 'Nam',
      dob: '2004-01-11',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 33,
      code: '1900177358',
      firstName: 'Đỗ Tiến',
      lastName: 'Tài',
      gender: 'Nam',
      dob: '2004-12-15',
      folk: 'Sán Dìu',
      age: 16,
      employee: true
    },
    {
      numberIndex: 34,
      code: '1900177360',
      firstName: 'Nguyễn Đức',
      lastName: 'Thắng',
      gender: 'Nam',
      dob: '2004-06-04',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 35,
      code: '1900177359',
      firstName: 'Nguyễn Công',
      lastName: 'Thành',
      gender: 'Nam',
      dob: '2004-06-21',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 36,
      code: '1900177361',
      firstName: 'Nguyễn Ngọc',
      lastName: 'Tiến',
      gender: 'Nam',
      dob: '2004-05-23',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 37,
      code: '1900177362',
      firstName: 'Nguyễn Văn Chí',
      lastName: 'Tôn',
      gender: 'Nam',
      dob: '2004-02-19',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 38,
      code: '1900177363',
      firstName: 'Nghiêm Xuân',
      lastName: 'Vinh',
      gender: 'Nam',
      dob: '2004-05-05',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 39,
      code: '1900177364',
      firstName: 'Nguyễn Văn',
      lastName: 'Vũ',
      gender: 'Nam',
      dob: '2004-04-01',
      folk: 'Kinh',
      age: 16,
      employee: true
    },
    {
      numberIndex: 40,
      code: '1900177365',
      firstName: 'Bùi Minh',
      lastName: 'Vương',
      gender: 'Nam',
      dob: '2004-03-02',
      folk: 'Kinh',
      age: 16,
      employee: true
    }
  ];

  ngOnInit() {
    //Chiều cao màng hình
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter()
    .subscribe(item => {
      this.checkCaculateHeight(this.isOpen);
    } );
    // this.contentHeight = this.elementView.nativeElement.offsetHeight;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
    this.cdRef.detectChanges();
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isOpen);
  }
  checkCaculateHeight(isOpen: boolean){
    if (isOpen === true) {
      setTimeout(() => {
        this.height = this.heightfnc() - this.elementPageExpandedSearch.nativeElement.offsetHeight;
        this.width = this.widthfnc();
      }, 1);
    } else {
      setTimeout(() => {
        this.height = this.heightfnc();
        this.width = this.widthfnc();
      }, 1);
    }
  }
  heightfnc(){
    return this.sizePageService.caculateHeight(
      this.elementBreadcrumb,
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation,
      this.heightContentPaddingtop,
      this.heightContentPaddingbottom);
  }
  widthfnc(){
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  onclickOpen() {
    this.maxHeight = window.innerHeight;
    this.isOpen = !this.isOpen;
    this.checkCaculateHeight(this.isOpen);
  }
  deleteRow(){

  }
  showPopup(): void {
    this.modalService.create({
      nzTitle: 'Đăng nhập',
      nzContent: PopupComponent,
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        'overflow-y': 'scroll',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px'
      },
      nzWidth: 1000
    });
  }
  openDrawer(): void {
    const drawerRef = this.drawerService.create<DrawerComponent, { value: string }, string>({
      nzTitle: 'Drawer',
      nzContent: DrawerComponent,
      nzContentParams: {
        value: ''
      },
      nzMaskClosable: false,
      nzBodyStyle: { overflow: 'auto' },
      nzWidth: 720
    });
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  onCurrentPageDataChange(listOfCurrentPageData): void {
    this.listOfData = listOfCurrentPageData;
    // this.refreshCheckedStatus();
  }
}
